/**
 * Executa via POST (com token CSRF) uma ação que antes era disparada por um link GET
 * (`<a href="...?action=delete_x&id=N">`). A query string do link é mantida na URL do POST —
 * os Controllers continuam lendo `id`/`propostaId` etc. via query(), e o `action` da URL casa
 * com a Action registrada como POST — e o token vai no corpo, validado pelo
 * #[ValidateCsrfToken]. A resposta (redirect) é seguida normalmente pelo navegador.
 * @param {string} url      URL completa da ação (normalmente o href do link)
 * @returns {Promise<void>}
 */
async function submitPostAction(url) {
    const csrfToken = await regenerateCsrfToken();
    if (!csrfToken) return;

    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;
    form.style.display = "none";

    const tokenField = document.createElement("input");
    tokenField.type = "hidden";
    tokenField.name = "csrf_token";
    tokenField.value = csrfToken;
    form.appendChild(tokenField);

    document.body.appendChild(form);
    form.submit();
}
